import React from "react";
import HomeBanner from '../components/homeBanner/homeBanner';
import KtempleNav from '../components/ktempleNav/ktempleNav';
import Gallery from '../components/Gallery/gallery';
import Footer from '../components/Footer/Footer';
import VisitingTemple from '../components/VisitingTemple/VisitingTemple';
import DocumentMeta from 'react-document-meta';
import Kirtan from "../components/kirtan/kirtan";
import TempleVideo from '../components/ktemplevideo/ktemplevideo';
import UpcomingEvents from "../components/upcomingevents/upcomingevents";

function GalleryPage() {
const meta = {
    title: "Picture Gallery - Radha Madhav Krishna Temple Milwaukee",
    description: "Explore the beautiful moments captured at the Radha Madhav Krishna Temple in Milwaukee. Our gallery showcases the essence of devotion and community.",
    keywords: "Gallery, Radha Madhav Krishna Temple, Milwaukee, photos, events"
  };
  return (
    <div>
      <DocumentMeta {...meta} />
      <KtempleNav />
      <UpcomingEvents />
      <HomeBanner />
      <Gallery />
      <TempleVideo />
      <Kirtan />
      <VisitingTemple />
      <Footer />
    </div>
  )
}

export default GalleryPage